import React, { useEffect, useState } from "react";
import MangeDashboard from "./ManageDashboard";
import { toast } from "react-toastify";
import { addBankAccount } from "../../services/bank";
import { useNavigate } from "react-router-dom";

export default function AddCard() {
  const [card, setCard] = useState("");
  const [sheba, setSheba] = useState("");
  const navigate = useNavigate();
  var IsSheba = new RegExp(/^[0-9]/);
  var IsDigit = new RegExp(/^[0-9]/);

  const [errorin, seterrorin] = useState({ card: "", sheba: "" });

  function handleCheck(event) {
    event.preventDefault();

    var tagName = event.target.name;
    let p = event.target.value;

    if (tagName == "card") {
      setCard(p);
      if (IsDigit.test(p)) {
        if (p.length == 16) {
          seterrorin({ ...errorin, card: "" });
        } else {
          seterrorin({
            ...errorin,
            card: "شماره کارت خود را به درستی وارد نمایید",
          });
        }
      } else {
        seterrorin({
          ...errorin,
          card: "شماره کارت خود را به درستی وارد نمایید",
        });
      }
    } else if (tagName == "sheba") {
      // console.log("sheba validation .......");
      setSheba(p);

      if (IsSheba.test(p) && p.length == 24) {
        seterrorin({ ...errorin, sheba: "" });
        setSheba(p);
      } else {
        seterrorin({
          ...errorin,
          sheba: "شماره شبا خود را به درستی وارد نمایید",
        });
      }
    }
  }

  function handleSubmit() {
    if (!card) {
      toast.error("شماره کارت خود را وارد نمایید");
    }

    addBankAccount(card)
      .then((res) => {
        if (res.status == 201) {
          toast.success("کارت شما با موفقیت ثبت شد");
          navigate(-1);
        } else {
          if (res.status.detail) {
            toast.error(res.status.detail);
          }
        }
      })
      .catch((error) => {});
  }

  return (
    <MangeDashboard>
      <div className="box-center5050">
        <div className="authincation section-padding">
          <div className="container h-100">
            <div className="row justify-content-center h-100 align-items-center">
              <div className="col-xl-5 col-md-8">
                <div className="mini-logo text-center my-2"></div>
                <div className="auth-form  custom-shadow">
                  <div className="card-body">
                    <form>
                      <div className="w-100 pt-2 pb-2">
                        <span className="d-flex pe-2 pb-1">
                          شماره کارت جدید
                        </span>
                        <input
                          name="card"
                          id={"card"}
                          className="form-input-custom"
                          value={card}
                          onChange={handleCheck}
                        />

                        {errorin.card && (
                          <span className="text-small text-danger padding-5612">
                            {errorin.card}
                          </span>
                        )}
                      </div>

                      <div className="w-100 pt-4 pb-2">
                        <button
                          className="form-input-button-custom"
                          type="button"
                          onClick={handleSubmit}
                        >
                          {false ? (
                            <img
                              src={"./loading.svg"}
                              alt={""}
                              className={"w-loading"}
                            />
                          ) : (
                            <>ثبت</>
                          )}
                        </button>
                      </div>
                      <div className="items-for-bottom-deposit">
                        <img
                          src="images/svg/warning-red.svg"
                          alt=""
                          className="image-padding-left-deposit"
                        />
                        <span className="red-color-alert">
                          برای اطلاع از تایید شماره کارت جدید به صفحه حساب
                          کاربری بخش مدیریت کارت های بانکی مراجعه کنید
                        </span>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MangeDashboard>
  );
}
